import {
    getSaleSettlementStatusCategoryToName,
    getSaleSettlementDetailCategoryToName,
    SaleSettlementStatusCategory,
    SaleSettlementDetailCategory,
} from '@web/slices/saleSettlement/slice'
import makeSlice from '@web/slices/search/sliceMaker'

function makeMulti<T extends object, F extends (value: string) => string>(
    obj: T,
    toName: F,
): {type: 'DEFAULT' | 'SINGLE' | 'MULTI'; code: string; name: string}[] {
    return [
        {
            type: 'DEFAULT',
            name: '전체',
            code: 'ALL',
        },
        ...Object.values(obj).map<{
            type: 'MULTI'
            name: string
            code: string
        }>((code) => {
            return {
                type: 'MULTI',
                name: toName(code),
                code,
            }
        }),
    ]
}

const searchSlice = makeSlice({
    initialState: {
        date: {
            type: 'DATE',
            max: 'ONE_YEAR_AFTER_DAY',
        },
        category: {
            title: '정산상태',
            items: makeMulti(SaleSettlementStatusCategory, getSaleSettlementStatusCategoryToName),
        },
        detail: {
            title: '정산항목',
            items: makeMulti(SaleSettlementDetailCategory, getSaleSettlementDetailCategoryToName),
        },
    },
    extraReducers: () => {
        /* empty */
    },
})

export default searchSlice.reducer
